import { useMemo } from 'react'
import {
  getSpaceManContract,
} from "utils/contractHelpers";

import useActiveWeb3React from 'hooks/useActiveWeb3React'

export const useSpaceManContract = () => {
  const { library } = useActiveWeb3React()
  return useMemo(() => getSpaceManContract(library.getSigner()), [library])
}
